import React from 'react';
import PropTypes from "prop-types";

import Request from "./Request";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";

const RequestsList = props => {

    const {requests, totalRequests, enableLoadMore, isLoadingMore, onLoadMore, onRequestResend} = props;
    const [expandedRequest, setExpandedRequest] = React.useState(false);

    const handleChange = (requestId) => (event, isExpanded) => {
        setExpandedRequest(isExpanded ? requestId : false);
    };

    return (
        <React.Fragment>
            <Box sx={{p: 1, display: "flex", flexDirection: "row-reverse"}}>
                <Typography variant="body2" color="textSecondary">
                    {requests.length} di {totalRequests}
                </Typography>
            </Box>

            <Box sx={{width: "100%", overflow: "hidden"}}>
                {
                    requests.map((x) => <Request key={x.id}
                                                 request={x}
                                                 isExpanded={x.id === expandedRequest}
                                                 onExpand={handleChange(x.id)}
                                                 onRequestResend={onRequestResend}/>)

                }
            </Box>
            {
                enableLoadMore &&
                <Box sx={{p: 4, display: "flex", justifyContent: "center"}}>
                    <LoadingButton color="primary"
                                   variant="contained"
                                   onClick={onLoadMore}
                                   loading={isLoadingMore}>
                        Carica altre richieste
                    </LoadingButton>
                </Box>
            }
        </React.Fragment>
    )
};

RequestsList.propTypes = {
    requests: PropTypes.arrayOf(PropTypes.object).isRequired,
    totalRequests: PropTypes.number.isRequired,
    enableLoadMore: PropTypes.bool.isRequired,
    isLoadingMore: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    onRequestResend: PropTypes.func.isRequired,
};

export default RequestsList;